import { render, staticRenderFns } from "./termination.vue?vue&type=template&id=ce20ea08&scoped=true"
import script from "./termination.vue?vue&type=script&lang=js"
export * from "./termination.vue?vue&type=script&lang=js"
import style0 from "./termination.vue?vue&type=style&index=0&id=ce20ea08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce20ea08",
  null
  
)

export default component.exports